import useAnnouncementModal from '../../hooks/useAnnouncementModal/'
import styles from 'shared/theme/vars/vars.js'
import { connect } from 'react-redux'
import Sidebar from './Sidebar'
import { Layout } from 'antd'
import React from 'react'

import './SidebarLayout.less'

const SidebarLayout = ({ children, profile }) => {
  useAnnouncementModal(profile)
  return (
    <Layout>
      <Layout.Sider className='main-sider' width={styles['@sidebar-width']}>
        <Sidebar />
      </Layout.Sider>
      <Layout.Content>{children}</Layout.Content>
    </Layout>
  )
}

export default connect(({ firebase: { profile } }) => ({
  profile
}))(SidebarLayout)
